"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _constant = require("../../../../constant");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _anchor = _interopRequireDefault(require("../../../base/anchor"));
var _blockEdit = _interopRequireDefault(require("../../../block-edit"));
var _styled = require("../../../base/styled");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var WritingItem = function WritingItem(_ref) {
  var hasApplicantOfWriting = _ref.hasApplicantOfWriting,
    links = _ref.links,
    onClickEdit = _ref.onClickEdit,
    isEdit = _ref.isEdit,
    applicant = _ref.applicant;
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.LEVEL_WRITING, false);
    },
    title: "Writing Samples",
    color: "#8E94B5",
    isEdit: isEdit,
    show: isEdit || !(0, _isEmpty.default)(links)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, links.map(function (link) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: link.title
    }, /*#__PURE__*/_react.default.createElement(_anchor.default, {
      url: link.url,
      title: link.title
    }));
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return {};
    },
    title: "Other Links",
    isEdit: false,
    color: "#8E94B5",
    show: hasApplicantOfWriting
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, applicant.transcriptShort && /*#__PURE__*/_react.default.createElement("li", {
    key: applicant.transcriptShort
  }, /*#__PURE__*/_react.default.createElement(_anchor.default, {
    url: applicant.transcriptShort,
    title: applicant.transcript
  })), applicant.portfolioUrlShort && /*#__PURE__*/_react.default.createElement("li", {
    key: applicant.portfolioUrlShort
  }, /*#__PURE__*/_react.default.createElement(_anchor.default, {
    url: applicant.portfolioUrlShort,
    title: applicant.portfolioUrl
  })))));
};
WritingItem.propTypes = {
  hasApplicantOfWriting: _propTypes.default.bool.isRequired,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  applicant: _utils.applicantPropTypes.isRequired,
  onClickEdit: _propTypes.default.func.isRequired,
  isEdit: _propTypes.default.bool.isRequired
};
var _default = WritingItem;
exports.default = _default;